import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getViewingRegion } from '@/dataImplementation/viewingRegionWeb'
import { BrandDetails } from '@vrw/data/src/redux/rewards/types'
import { QueryParamsThatChangeReturnType } from '../query-type-helpers'
import { getRedDataApiPaths } from '@vrw/data/src/config'
import { get } from '@vrw/data/src/utils/httpClient'

type UseBrandsProps = Omit<UseQueryOptions<BrandDetails[]>, QueryParamsThatChangeReturnType>

const useBrands = (props: UseBrandsProps = {}) => {
  const viewingRegion = getViewingRegion()

  const { data: brands, ...rest } = useQuery({
    queryKey: ['brands', viewingRegion],
    queryFn: async (): Promise<BrandDetails[]> =>
      (await get(`${getRedDataApiPaths().RED_API_DISCOVERY_BRANDS}?viewingRegion=${viewingRegion}`, true)).brands,
    ...props,
  })

  return { brands, ...rest }
}

export default useBrands
